import { h, Component } from 'preact';
import { Link } from 'components/core/link/link';
import HTML from 'components/core/html/html';
import { accessNested, sortObjectByOrder, joinClasses, condClass, getStylingImagePath } from 'utils/utils';
import { getCopy } from 'utils/copy';
import s from 'components/shared/footer/footer.sss';
import pure from 'utils/pure';

class NoRerenderDiv extends Component {
	shouldComponentUpdate() {
		return false;
	}

	render(props) {
		let {
			type: Tag = 'div',
			children,
			...attributes
		} = props;
		return <Tag {...attributes}>{children}</Tag>;
	}
}

export default @pure class Footer extends Component {

	//////////////////
	/// LIFE CYCLE ///
	//////////////////

	constructor() {
		super();
		this.state.footerEmbedActive = false;

		this.toggleFooter = this.toggleFooter.bind(this);
		this.$links = [];
	}

	//////////////////////
	/// CLICK HANDLERS ///
	//////////////////////

	toggleFooter() {
		this.setState({ footerEmbedActive: !this.state.footerEmbedActive });
	}

	/////////////////
	/// FUNCTIONS ///
	/////////////////

	// Easily add something to footer in overrides
	getExtraContent() { }

	getExtraContentOutside() { }

	getPrependContent() { }

	getStudioLink() {
		const appData = this.props.appData || {};
		const footer = appData.footer;
		if (!footer || footer.disableStudioLogo) {
			return;
		}

		const defaultPath = appData.urls.roots.image + '/' + (footer.studioLogo || 'legal-logos.png');
		const src = getStylingImagePath(this.props.appData, 'legal-logos', defaultPath);
		let result = <img class={s.studio} alt={footer.studioLogoAltText || 'footer-studioLogo'} src={src} />;

		if (footer.studioLogoLink) {
			result = (
				<Link
					trackId="studio-logo"
					href={footer.studioLogoLink}
					target="_blank"
				>
					{result}
				</Link>
			);
		}

		return result;
	}

	getLinkListItem(item, key, copy, className, linkClass, noLinkClass) {
		const extraProps = {};
		if (item.url) {
			extraProps.href = item.url;
			extraProps.target = item.target || '_blank';
		} else if (item.pageId) {
			extraProps.pageId = item.pageId;
			item.target && (extraProps.target = item.target);
		}

		if (item.id) {
			extraProps.id = item.id;
		}

		if (item.title) {
			extraProps.title = item.title;
		}

		if (item.ariaLabel) {
			extraProps.ariaLabel = item.ariaLabel;
		}

		let contentText = copy[item.$copy] || item.$copy;

		let content;
		if (item.blockRerender) {
			content = (
				<HTML
					tag={NoRerenderDiv}
					{...extraProps}
					type={item.type}
					class={noLinkClass}
					content={contentText}
					markdown={!item.noMarkdown}
				/>
			);
		} else if (item.url || item.pageId) {
			content = (
				<HTML
					tag={Link}
					{...extraProps}
					trackId={item.trackId}
					linkClass={linkClass}
					content={contentText}
					markdown={!item.noMarkdown}
					extraOnClick={item.onClick && (typeof item.onClick === 'function' ? item.onClick : this[item.onClick])}
				/>
			);
		} else {
			content = (
				<HTML
					tag="span"
					{...extraProps}
					class={noLinkClass}
					content={contentText}
					markdown={!item.noMarkdown}
				/>
			);
		}

		return (
			<li
				ref={e => this.$links[key] = e}
				class={joinClasses(className, s['link-' + key])}
			>
				{content}
			</li>
		);
	}

	getLinkList(items, className, linkClass, noLinkClass) {
		const copy = this.props.appData.copy || this.props.copyObj;
		return sortObjectByOrder(items || {}, (item, key) => this.getLinkListItem(item, key, copy, className, linkClass, noLinkClass));
	}

	getLinks() {
		return this.getLinkList(accessNested(this.props, 'appData.footer.links'), s.listItem, s.listLink, s.listNoLink);
	}

	getCopyright() {
		return this.getLinkList(accessNested(this.props, 'appData.footer.copyright'), s.copyrightListItem, s.copyrightLink, s.copyrightNoLink);
	}

	//////////////
	/// RENDER ///
	//////////////

	render(props) {
		const {
			appData = {},
			activePage, // object
			client // Object
		} = props;

		let copy = appData.copy ? appData.copy : props.copy;
		const footer = appData.footer || {};
		if (!footer) return;

		const embedMode = (client && client.embedMode) || appData.options.popupFooter;

		let textCopyright;
		if (footer.textCopyright) {
			const pid = activePage && activePage.id.toUpperCase();
			const $copy = footer.textCopyright.$copy;
			let textCopyrightTxt = copy['$' + pid + '_' + $copy] || copy['$' + $copy];
			if (textCopyrightTxt) {
				textCopyright = <HTML tag="p" markdown class={s.copyrightText}>{textCopyrightTxt}</HTML>;
			}
		}

		let embedButtons;
		if (embedMode) {
			embedButtons = [
				<button class={s.toggle} onClick={this.toggleFooter}>{getCopy('SHOW_LEGALS') || 'Legals'}</button>
			];
			if (this.state.footerEmbedActive === true) {
				embedButtons.push(
					<div class={s.invisible} onClick={this.toggleFooter} />
				);
			}
		}

		return (
			<footer class={s.footer + condClass(embedMode, s.embed) + condClass(this.state.footerEmbedActive, s.embedActive)} ref={ref => this.$footer = ref}>
				{embedButtons}
				<div class={s.content}>
					{this.getPrependContent()}
					{this.getStudioLink()}
					<ul class={s.list}>{this.getLinks()}</ul>
					<ul class={s.listInline}>{this.getCopyright()}</ul>
					{textCopyright}
					{this.getExtraContent()}
				</div>
				{this.getExtraContentOutside()}
			</footer>
		);
	}

}
